import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
  Button,
  FormGroup,
  Col,
  Row,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CustomCheckbox from '../../CustomCheckbox';
import CommonFormComponent from '../../CommonField/CommonFormComponent';

import { createAdminRole } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';
import validate from './validate';

import s from './AdminRolesForm.css';
import cp from '../../../components/commonStyle.css';
import messages from '../../../locale/jsonMessages';
class AdminRolesForm extends Component {

  renderCheckbox = ({ input, labelText, meta: { touched, error }, options, className, isRequiredInput }) => {
    const { formatMessage } = this.props.intl;
    let currentValue = input.value || [];
    return (
      <div>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        <label className='commonLabelText'>{labelText}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</label>
        <Row>
          {
            options?.length > 0 && options?.filter(option => option.isEnable === true).map((option, index) => {
              return (
                <Col lg={6} md={6} key={index} className={s.checkboxLabelContainer}>
                  <CustomCheckbox
                    {...input}
                    className='commonCustomCheckBox normalSizeCheckBox'
                    containerClassName={cx(s.labelFontWeightNormal, 'commonCustomCheckFlex')}
                    label={option.privilege}
                    value={option.id}
                    name={`${input.name}[${index}]`}
                    checked={currentValue.indexOf(option.id) !== -1}
                    onChange={(event) => {
                      const newValue = [...currentValue] || [];
                      if (event === true) {
                        newValue.push(option.id);
                      } else {
                        newValue.splice(newValue.indexOf(option.id), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                </Col>
              )
            })
          }
        </Row>
      </div>
    );
  }

  handleFormSubmit = async (values) => {
    const { createAdminRole, paginationData } = this.props;
    const response = await createAdminRole(
      values.id,
      values.name,
      values.description,
      values.privileges
    );
    if (response && response.status === 200) {
      paginationData(1);
    }
  }

  render() {
    const { error, handleSubmit, submitting, id, privileges } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <form onSubmit={handleSubmit(this.handleFormSubmit)}>
        {error && <strong>{formatMessage(error)}</strong>}
        <div className="oneColumnGrid">
          <Field
            name="name"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.roleNameLabel)}
            labelText={formatMessage(messages.roleNameLabel)}
            inputClass='commonInputField'
            isRequiredInput
          />

          <Field
            name="description"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.descriptionAdminLabel)}
            inputClass='commonTextAreaField'
            labelText={formatMessage(messages.descriptionAdminLabel)}
            componentClass={"textarea"}
          />
          <Field
            name="privileges"
            component={this.renderCheckbox}
            options={privileges}
            labelText={formatMessage(messages.privilegesLabel)}
            isRequiredInput
          />
        </div>

        <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
          <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting}>
            {id ? <FormattedMessage  {...messages.update} /> : <FormattedMessage  {...messages.addLabel} />}
          </Button>
        </div>
      </form>
    )
  }

}

AdminRolesForm = reduxForm({
  form: "AdminRolesForm", // a unique name for this form
  validate,
})(AdminRolesForm);

const selector = formValueSelector('AdminRolesForm');

const mapState = (state) => ({
  id: selector(state, 'id'),
  privileges: state.listSettings.privileges
});

const mapDispatch = {
  createAdminRole
};

export default injectIntl(withStyles(s, cp)(connect(mapState, mapDispatch)(AdminRolesForm)));